import { IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { type PerfectDayScene } from "@/lib/backend/api";
import { cx } from "@/lib/style/cva.config";

export function ChatSceneSummary({
	className,
	scene,
	...props
}: React.ComponentPropsWithoutRef<"div"> & {
	scene: PerfectDayScene;
}) {
	const { t } = useTranslation();

	return (
		<div {...props} className={cx("ms-3 me-auto w-full max-w-[90%]", className)}>
			<div className="bg-brown-300 relative overflow-hidden rounded-2xl">
				<div className="absolute bottom-0 -left-3 size-3 rounded-full" />

				{scene.imageUrl && (
					<div className="relative h-full w-full">
						<img
							src={scene.imageUrl}
							alt={t("perfect-day.details.image-alt")}
							className="h-full w-full object-cover"
						/>
						<div className="from-brown-300/100 absolute right-0 bottom-0 left-0 h-16 w-full bg-linear-to-t to-transparent" />
					</div>
				)}

				<div className="px-3 py-3">
					<div className="mb-2 flex items-center gap-2">
						<IonText data-mask-text className="text-brown-700 text-2xl font-bold">
							{scene.name}
						</IonText>
					</div>
					<p data-mask-text className="text-brown-700 font-medium">
						{scene.chat.summary}
					</p>
				</div>
			</div>
		</div>
	);
}
